import { render, staticRenderFns } from "./SaleEditContactExtraInfoEdit.vue?vue&type=template&id=235a82ac&scoped=true"
import script from "./SaleEditContactExtraInfoEdit.vue?vue&type=script&lang=ts"
export * from "./SaleEditContactExtraInfoEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235a82ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('235a82ac')) {
      api.createRecord('235a82ac', component.options)
    } else {
      api.reload('235a82ac', component.options)
    }
    module.hot.accept("./SaleEditContactExtraInfoEdit.vue?vue&type=template&id=235a82ac&scoped=true", function () {
      api.rerender('235a82ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/SaleEditContactExtraInfoEdit.vue"
export default component.exports